<template>
  <div class="taktboxes-container">
    <h1>TAKT.boxes</h1>
    <v-card>
      <v-card-title>Register a new TAKT.box</v-card-title>
      <v-card-text>
        Click "Register TAKT.box" to create a new TAKT.box for your project.
      </v-card-text>
      <v-card-actions>
        <v-btn @click="show_scanner = true">Register TAKT.box</v-btn>
        <!-- <v-btn @click="onDecode('c8cef808-5a2d-482d-9d99-f524c27e5647')">Test TAKT.box</v-btn> -->
      </v-card-actions>
    </v-card>
    <div class="qr-scanner" v-if="show_scanner">
      <qrcode-stream @decode="onDecode" :track="paintOutline"></qrcode-stream>
    </div>
    <v-card v-for="taktbox in taktboxes" :key="`taktbox${taktbox.id}`">
      <v-card-title>{{ taktbox.id }}</v-card-title>
      <v-card-text>
        <TText value="Active" />: {{ taktbox.active }}
        <!-- if taktbox has attribute temperature and its length is bigger than 0 display the data in a table with the values: timestamp, temperature_f,temperature_c and humidity -->
        <template v-if="taktbox.temperature && taktbox.temperature.length > 0">
          <h2>Temperature</h2>
          <v-data-table
            :headers="[
              { text: 'Timestamp', value: 'timestamp' },
              { text: 'Temperature (F)', value: 'temperature_f' },
              { text: 'Temperature (C)', value: 'temperature_c' },
              { text: 'Humidity', value: 'humidity' },
            ]"
            :items="taktbox.temperature"
            :items-per-page="5"
            class="elevation-1"
          ></v-data-table>
        </template>
      </v-card-text>
      <!-- card actions with a button to request sensor data -->
      <v-card-actions>
        <v-btn @click="requestSensorData(taktbox.id)">Request Sensor Data</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import store from '@/store/index'


import { mapActions, mapGetters } from 'vuex';

export default {
  components: {

  },
  name: 'ProjectTaktboxes',
  data: function () {
    return {
      show_scanner: false,
    };
  },
  created() {
    store.dispatch('Ultra/requestUObject', {
      url: [
        { projects: this.project_id },
        { taktboxes: '' },
        { showWithEntitiesNormalized: '' }
      ]
    });
  },
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject'
    ]),
    project_id() {
      return this.$route.params.project_id;
    },
    taktboxes(){
      return this.getUObjects({type:'taktboxes', ids: this.$store.state.Ultra.projects[this.project_id].taktboxes});
    }
  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    onDecode(decoded) {
      console.log('decoded', decoded);
      this.show_scanner = false;
      this.createUObject({
        url: [
          { projects: this.project_id },
          { taktboxes: '' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: {
          code: decoded
        }
      });
    },
    requestSensorData(id){
      store.dispatch('Ultra/requestUObject', {
        url: [
          { projects: this.project_id },
          { taktboxes: id },
          { showWithEntitiesNormalized: '' }
        ],
        url_suffix: '&sensor_data=true'
      });
    },
    paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

        ctx.strokeStyle = "red";

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.taktboxes-container {
  width: 90%;
  margin-left: 5%;
}

.qr-scanner {
  border: 1px solid rgba(0, 0, 0, 0.25);
  height: 250px;
  border-radius: 4px;
  z-index: 15;
}

.qr-scanner-cancel {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 18;
}
</style>
